export interface CustomerLocation {
  id: number;
  searchCode: string;
  name: string;
}

export interface LocationOption {
  value: string;
  label: string;
}

export const LOCATION_REQUIRED_FROM_COUNT = 2;

export const isCustomerLocationRequired = (customerLocations: CustomerLocation[]) =>
  customerLocations.length >= LOCATION_REQUIRED_FROM_COUNT;
